





































































































































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import { uniq } from "lodash";

import { STORE_KEY, store } from "./_store";
import ProductTypeForm from "@/modules/ProductCatalog/ProductTypeForm/ProductTypeForm.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, ["loading", "loaded"]),
    ...mapGetters(STORE_KEY, ["structureTree"])
  }
})
export default class StructureTab extends Vue {
  loading!: boolean;
  structureTree!: any[];

  opened: any[] = [];

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
      console.debug("[ProductDirectory.Structure.created] registered", {
        STORE_KEY
      });
    }
  }

  public mounted() {
    this.reload();
  }

  public beforeDestroy() {
    console.debug("[ProductDirectory.Structure.beforeDestroy] unregister", {
      STORE_KEY
    });
    this.$store.unregisterModule(STORE_KEY);
  }

  reload() {
    console.debug("[ProductDirectory.Structure.reload]");
    return this.$store.dispatch(`${STORE_KEY}/loadStructure`);
  }

  hasDetailedVisible(row: any) {
    return !!(row.children && row.children.length > 0);
  }

  structureRowClass(row: any) {
    const classes = [];
    if (row.type === "type") {
      classes.push("catalog-row-type");
    }
    if (row.archived_at) {
      classes.push("is-archived");
    }
    return classes.join(" ");
  }

  onDetailToggle(row: any, to: string) {
    if (to == "open") {
      this.opened = uniq([...this.opened, row.id]);
    } else {
      this.opened = uniq(this.opened.filter(($row) => $row.id != row.id));
    }
  }

  toggleArchive(row: any) {
    const isArchived = !!row.archived_at;
    const action = isArchived
      ? `${STORE_KEY}/productTypeToUnarchive`
      : `${STORE_KEY}/productTypeToArchive`;
    const successMessage = isArchived
      ? row.type === "parent"
        ? "Родительский продукт восстановлен"
        : "Тип восстановлен"
      : row.type === "parent"
      ? "Родительский продукт помечен архивным"
      : "Тип помечен архивным";

    const run = () =>
      this.$store
        .dispatch(action, row.id)
        .then(() => {
          this.$buefy.snackbar.open(successMessage);
          this.reload();
        })
        .catch(() => {
          this.$buefy.snackbar.open({
            type: "is-warning",
            message: "При сохранении возникли проблемы. Попробуйте позже."
          });
        });

    if (isArchived) {
      run();
      return;
    }

    this.$buefy.dialog.confirm({
      message:
        row.type === "parent"
          ? "Отправить родительский продукт в архив?"
          : "Отправить тип в архив?",
      confirmText: "В архив",
      cancelText: "Отмена",
      type: "is-danger",
      onConfirm: run
    });
  }

  openProductType(row: any, parent_id: any = null) {
    const isNew = !row || !row.id;
    const recordType =
      row && row.record_type
        ? row.record_type
        : parent_id
        ? "parent_product"
        : "type";

    console.debug("[ProductDirectory.Structure.openProductType]", {
      isNew,
      record_type: recordType,
      parent_id: parent_id || (row && row.parent_id),
      id: row && row.id
    });

    this.$buefy.modal.open({
      component: ProductTypeForm,
      props: {
        isNew,
        nameEditable: true,
        documentPreview: row,
        initParams: isNew
          ? {
              record_type: recordType,
              ...(parent_id ? { parent_id } : {})
            }
          : {}
      },
      events: {
        "form-close": () => {
          console.info("[ProductDirectory.Structure] form-close → reload");
          this.reload();
        }
      },
      hasModalCard: true,
      fullScreen: true,
      customClass:
        recordType === "parent_product"
          ? "document-form"
          : "document-form short-form",
      parent: this
    });
  }

  openParentProduct(row: any, type_id: any) {
    this.openProductType(row, type_id);
  }
}
